import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { AccessRequest, AccessRequestStatus } from 'icreate/common/models/access-request';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AccessRequestService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    private currentAccessRequestId: string;

    getCurrentAccessRequestId() {
        return this.currentAccessRequestId;
    }

    setCurrentAccessRequestId(requestId: string) {
        this.currentAccessRequestId = requestId;
    }

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async requestAccess(userName, userOid, vesselId, version, requestStatus?): Promise<any> {
        return await lastValueFrom(
            this.http.post<any>(
                `${this.domain}/api/accessRequest`,
                {
                    skipGuard: true,
                    userName,
                    userOid,
                    version,
                    vesselId,
                    requestStatus,
                },
                this.headers
            )
        );
    }

    async getRequests(vesselId): Promise<AccessRequest[]> {
        return await lastValueFrom(this.http.get<AccessRequest[]>(`${this.domain}/api/accessRequest/${vesselId}`));
    }

    async acceptRequest(requestId) {
        return await lastValueFrom(
            this.http.put<any>(
                `${this.domain}/api/accessRequest/${requestId}`,
                { requestStatus: AccessRequestStatus.Accepted },
                this.headers
            )
        );
    }

    async rejectRequest(requestId) {
        return await lastValueFrom(
            this.http.put<any>(
                `${this.domain}/api/accessRequest/${requestId}`,
                { requestStatus: AccessRequestStatus.Rejected },
                this.headers
            )
        );
    }

    async startEdit(requestId) {
        return await lastValueFrom(
            this.http.put<any>(
                `${this.domain}/api/accessRequest/${requestId}`,
                { requestStatus: AccessRequestStatus.Editing, skipGuard: true },
                this.headers
            )
        );
    }

    async finishEdit(requestId) {
        return await lastValueFrom(
            this.http.put<any>(
                `${this.domain}/api/accessRequest/${requestId}`,
                { requestStatus: AccessRequestStatus.Finished, skipGuard: true },
                this.headers
            )
        );
    }

    async leaveEdit(requestId) {
        return await lastValueFrom(
            this.http.put<any>(
                `${this.domain}/api/accessRequest/${requestId}`,
                { requestStatus: AccessRequestStatus.Leave },
                this.headers
            )
        );
    }

    async removeAccess(editorUser) {
        return await lastValueFrom(
            this.http.put<any>(
                `${this.domain}/api/accessRequest/removeAccess/${editorUser.requestId}`,
                {
                    skipGuard: true,
                    editorUser,
                },
                this.headers
            )
        );
    }

    async sendStopEditingBeacon(requestId: string) {
        navigator.sendBeacon(`${this.domain}/api/accessRequest/finish-edit?requestId=${requestId}`);
    }
}
